/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ColumnVisibility,
    ColumnVisibilityFromJSON,
    ColumnVisibilityToJSON,
} from '../models/ColumnVisibility';
import {
    type ColumnVisibilityUpdate,
    ColumnVisibilityUpdateFromJSON,
    ColumnVisibilityUpdateToJSON,
} from '../models/ColumnVisibilityUpdate';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';

export interface ColumnVisibilityUpdateColumnVisibilityRequest {
    id: string;
    columnVisibilityUpdate: ColumnVisibilityUpdate;
}

export interface ColumnVisibilityValidateUpdateColumnVisibilityRequest {
    id: string;
    columnVisibilityUpdate: ColumnVisibilityUpdate;
}

/**
 * ColumnVisibilitysApi - interface
 * 
 * @export
 * @interface ColumnVisibilitysApiInterface
 */
export interface ColumnVisibilitysApiInterface {
    /**
     * Creates request options for columnVisibilityReadColumnVisibility without sending the request
     * @throws {RequiredError}
     * @memberof ColumnVisibilitysApiInterface
     */
    columnVisibilityReadColumnVisibilityRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * Since there\'s only a single column visibility row, we don\'t take an ID parameter here.
     * @summary Fetch the column visibility entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ColumnVisibilitysApiInterface
     */
    columnVisibilityReadColumnVisibilityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ColumnVisibility>>;

    /**
     * Since there\'s only a single column visibility row, we don\'t take an ID parameter here.
     * Fetch the column visibility entity
     */
    columnVisibilityReadColumnVisibility(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ColumnVisibility>;

    /**
     * Creates request options for columnVisibilityUpdateColumnVisibility without sending the request
     * @param {string} id 
     * @param {ColumnVisibilityUpdate} columnVisibilityUpdate 
     * @throws {RequiredError}
     * @memberof ColumnVisibilitysApiInterface
     */
    columnVisibilityUpdateColumnVisibilityRequestOpts(requestParameters: ColumnVisibilityUpdateColumnVisibilityRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the column visibility entity. Since we know the ID of the singleton entity after reading, we take an ID argument here to keep the API consistent with other update endpoints.
     * @summary Update column visibility
     * @param {string} id 
     * @param {ColumnVisibilityUpdate} columnVisibilityUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ColumnVisibilitysApiInterface
     */
    columnVisibilityUpdateColumnVisibilityRaw(requestParameters: ColumnVisibilityUpdateColumnVisibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ColumnVisibility>>;

    /**
     * Update the column visibility entity. Since we know the ID of the singleton entity after reading, we take an ID argument here to keep the API consistent with other update endpoints.
     * Update column visibility
     */
    columnVisibilityUpdateColumnVisibility(requestParameters: ColumnVisibilityUpdateColumnVisibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ColumnVisibility>;

    /**
     * Creates request options for columnVisibilityValidateUpdateColumnVisibility without sending the request
     * @param {string} id 
     * @param {ColumnVisibilityUpdate} columnVisibilityUpdate 
     * @throws {RequiredError}
     * @memberof ColumnVisibilitysApiInterface
     */
    columnVisibilityValidateUpdateColumnVisibilityRequestOpts(requestParameters: ColumnVisibilityValidateUpdateColumnVisibilityRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate an update struct for the column visibility entity.
     * @summary Validate column visibility update
     * @param {string} id 
     * @param {ColumnVisibilityUpdate} columnVisibilityUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ColumnVisibilitysApiInterface
     */
    columnVisibilityValidateUpdateColumnVisibilityRaw(requestParameters: ColumnVisibilityValidateUpdateColumnVisibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate an update struct for the column visibility entity.
     * Validate column visibility update
     */
    columnVisibilityValidateUpdateColumnVisibility(requestParameters: ColumnVisibilityValidateUpdateColumnVisibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ColumnVisibilitysApi extends runtime.BaseAPI implements ColumnVisibilitysApiInterface {

    /**
     * Creates request options for columnVisibilityReadColumnVisibility without sending the request
     */
    async columnVisibilityReadColumnVisibilityRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/column_visibilitys/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Since there\'s only a single column visibility row, we don\'t take an ID parameter here.
     * Fetch the column visibility entity
     */
    async columnVisibilityReadColumnVisibilityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ColumnVisibility>> {
        const requestOptions = await this.columnVisibilityReadColumnVisibilityRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ColumnVisibilityFromJSON(jsonValue));
    }

    /**
     * Since there\'s only a single column visibility row, we don\'t take an ID parameter here.
     * Fetch the column visibility entity
     */
    async columnVisibilityReadColumnVisibility(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ColumnVisibility> {
        const response = await this.columnVisibilityReadColumnVisibilityRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for columnVisibilityUpdateColumnVisibility without sending the request
     */
    async columnVisibilityUpdateColumnVisibilityRequestOpts(requestParameters: ColumnVisibilityUpdateColumnVisibilityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling columnVisibilityUpdateColumnVisibility().'
            );
        }

        if (requestParameters['columnVisibilityUpdate'] == null) {
            throw new runtime.RequiredError(
                'columnVisibilityUpdate',
                'Required parameter "columnVisibilityUpdate" was null or undefined when calling columnVisibilityUpdateColumnVisibility().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/column_visibilitys/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ColumnVisibilityUpdateToJSON(requestParameters['columnVisibilityUpdate']),
        };
    }

    /**
     * Update the column visibility entity. Since we know the ID of the singleton entity after reading, we take an ID argument here to keep the API consistent with other update endpoints.
     * Update column visibility
     */
    async columnVisibilityUpdateColumnVisibilityRaw(requestParameters: ColumnVisibilityUpdateColumnVisibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ColumnVisibility>> {
        const requestOptions = await this.columnVisibilityUpdateColumnVisibilityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ColumnVisibilityFromJSON(jsonValue));
    }

    /**
     * Update the column visibility entity. Since we know the ID of the singleton entity after reading, we take an ID argument here to keep the API consistent with other update endpoints.
     * Update column visibility
     */
    async columnVisibilityUpdateColumnVisibility(requestParameters: ColumnVisibilityUpdateColumnVisibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ColumnVisibility> {
        const response = await this.columnVisibilityUpdateColumnVisibilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for columnVisibilityValidateUpdateColumnVisibility without sending the request
     */
    async columnVisibilityValidateUpdateColumnVisibilityRequestOpts(requestParameters: ColumnVisibilityValidateUpdateColumnVisibilityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling columnVisibilityValidateUpdateColumnVisibility().'
            );
        }

        if (requestParameters['columnVisibilityUpdate'] == null) {
            throw new runtime.RequiredError(
                'columnVisibilityUpdate',
                'Required parameter "columnVisibilityUpdate" was null or undefined when calling columnVisibilityValidateUpdateColumnVisibility().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/column_visibilitys/{id}/validate`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ColumnVisibilityUpdateToJSON(requestParameters['columnVisibilityUpdate']),
        };
    }

    /**
     * Validate an update struct for the column visibility entity.
     * Validate column visibility update
     */
    async columnVisibilityValidateUpdateColumnVisibilityRaw(requestParameters: ColumnVisibilityValidateUpdateColumnVisibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.columnVisibilityValidateUpdateColumnVisibilityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate an update struct for the column visibility entity.
     * Validate column visibility update
     */
    async columnVisibilityValidateUpdateColumnVisibility(requestParameters: ColumnVisibilityValidateUpdateColumnVisibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.columnVisibilityValidateUpdateColumnVisibilityRaw(requestParameters, initOverrides);
    }

}
